<div class="relative">
    <ng-content></ng-content>
    @if (display) {
        <div class="absolute top-[-4px] left-[16px] bg-red-700 rounded-full size-4 text-xs text-center card-shadow font-mono">!</div>
    }
</div>